import { TextField, Typography, Card, CardContent, Box, Grid, Stack, IconButton, Tooltip, MenuItem, Button, Avatar } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useState, useEffect } from "react";
import { verifyDomainAction } from "../../Actions/TenantActions";
import { MyVerifiedIcon, MyPersonIcon } from "../../Assets/svg/MyIcons";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const baseDomain = "netcluesdemo.com";

const TripolaInformationStep = ({ tenantId = null, formik, tenantCurrencies = [], handleEditing, isEditing, setIsTripolaEdit, setLogoRemoved, isTrialPortalCreation }) => {
	const [buttonColor, setButtonColor] = useState(() => tenantId ? "success" : "");
	// const [isButtonDisabled, setIsButtonDisabled] = useState(false);
	const [responseMessage, setResponseMessage] = useState("");
	const [previousDomain, setPreviousDomain] = useState("");
	const [isManuallyEdited, setIsManuallyEdited] = useState(false);
	const [tripolaCompanyLogoPreview, setTripolaCompanyLogoPreview] = useState(`https://tripolaav2image.netcluesdemo.com/uploads/logo/${formik.values.tripolaCompanyLogo}` || "");



	const handleCompanyNameChange = (e) => {
		formik.setFieldValue(e.target.name, e.target.value.replace(/^\s+/, ''));
		formik.setFieldTouched(e.target.name, true, false);
	};

	const handleEmailChange = (e) => {
		formik.setFieldValue(e.target.name, e.target.value.replace(/\s/g, ''));
		formik.setFieldTouched(e.target.name, true, false);
	};

	const handleZipCodeChange = (e) => {
		const newValue = e.target.value.replace(/[^a-zA-Z0-9\-\u2013\u2014]/g, '');
		formik.setFieldValue(e.target.name, newValue);
		formik.setFieldTouched(e.target.name, true, false);
	};

	const generateFullDomain = (subdomain) => {
		if (!subdomain) return "";
		const cleanSubdomain = subdomain.trim().replace(/\s+/g, "").replace(/[^a-zA-Z0-9-]/g, "").toLowerCase();
		return cleanSubdomain ? `${cleanSubdomain}.${baseDomain}` : "";
	};

	const extractSubdomain = (fullDomain) => {
		if (!fullDomain) return "";
		return fullDomain.replace(`.${baseDomain}`, "").trim();
	};

	const isValidSubdomain = (subdomain) => {
		const subdomainRegex = /^[a-z0-9-]+$/;
		return subdomainRegex.test(subdomain);
	};

	const verifyDomainURL = async () => {
		try {
			const domainUrl = formik.values.tripolaDomainUrl;
			if (!domainUrl) {
				formik.setFieldValue("tripolaIsVerified", false);
				setResponseMessage("Please enter a domain");
				setButtonColor("error");
				return;
			}
			const response = await verifyDomainAction({ domainUrl });
			if (response?.data?.status === 200) {
				setButtonColor("error");
				setResponseMessage("Domain already exists");
				formik.setFieldValue("tripolaIsVerified", false);
				// setIsButtonDisabled(false);
			} else if (response?.data?.status === 202) {
				setButtonColor("success");
				setResponseMessage("Domain verified successfully");
				formik.setFieldValue("tripolaIsVerified", true);
				// setIsButtonDisabled(true);
			}
			setTimeout(() => setResponseMessage(""), 3000);
		} catch (error) {
			setButtonColor("error");
			setResponseMessage(error?.response?.data?.message || "Verification failed. Try again.");
			formik.setFieldValue("tripolaIsVerified", false);
			// setIsButtonDisabled(false);
		}
	};

	const handleEditClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setPreviousDomain(formik.values.tripolaDomainUrl);
		const subdomain = extractSubdomain(formik.values.tripolaDomainUrl);
		formik.setFieldValue("tripolaDomainUrl", subdomain);
		handleEditing(true);
		setButtonColor("");
		formik.setFieldValue("tripolaIsVerified", false);
		// setIsButtonDisabled(false);
		setResponseMessage("");
	};

	const handleSaveDomainUrl = (e) => {
		e.preventDefault();
		e.stopPropagation();
		const subdomain = formik.values.tripolaDomainUrl.trim();
		if (!subdomain) {
			formik.setFieldError("tripolaDomainUrl", "Please enter a subdomain");
			return;
		}
		if (!isValidSubdomain(subdomain)) {
			formik.setFieldError("tripolaDomainUrl", "Subdomain can only contain lowercase letters, numbers, and hyphens");
			return;
		}
		const fullDomain = generateFullDomain(subdomain);
		formik.setFieldError("tripolaDomainUrl", "");
		formik.setFieldValue("tripolaDomainUrl", fullDomain, false);
		formik.setFieldValue("tripolaIsVerified", false, false);
		formik.setFieldTouched("tripolaDomainUrl", false, false);
		setButtonColor("");
		// setIsButtonDisabled(false);
		setResponseMessage("");
		setIsManuallyEdited(true);
		handleEditing(false);
	};

	const handleCancelEdit = (e) => {
		e.preventDefault();
		e.stopPropagation();
		formik.setFieldValue("tripolaDomainUrl", previousDomain || generateFullDomain(formik.values.companyName));
		formik.setFieldError("tripolaDomainUrl", "");
		handleEditing(false);
		setResponseMessage("");
	};

	const handletripolaCompanyLogoChange = (e) => {
		const file = e.target.files?.[0];
		if (file) {
			const validTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
			if (!validTypes.includes(file.type)) {
				formik.setFieldError("tripolaCompanyLogo", "Please upload a valid image file (JPEG, PNG, GIF, or WebP)");
				return;
			}
			const maxSize = 5 * 1024 * 1024;
			if (file.size > maxSize) {
				formik.setFieldError("tripolaCompanyLogo", "File size must be less than 5MB");
				return;
			}
			const reader = new FileReader();
			reader.onloadend = () => {
				setTripolaCompanyLogoPreview(reader.result);
				formik.setFieldValue("tripolaCompanyLogo", file);
				formik.setFieldError("tripolaCompanyLogo", "");
				setIsTripolaEdit(true);
			};
			reader.readAsDataURL(file);
		}
	};

	const handleRemovetripolaCompanyLogo = () => {
		setTripolaCompanyLogoPreview("");
		formik.setFieldValue("tripolaCompanyLogo", "");
		formik.setFieldError("tripolaCompanyLogo", "");
		if (setLogoRemoved) {
			setLogoRemoved(true);
		}
		setIsTripolaEdit(true);
	};

	useEffect(() => {

		const logoValue =
			formik.values.tripolaCompanyLogo || formik.values.tripolaCompanyLogo;

		if (logoValue) {

			// File object
			if (logoValue instanceof File) {

				const reader = new FileReader();

				reader.onloadend = () => {
					setTripolaCompanyLogoPreview(reader.result);
				};

				reader.readAsDataURL(logoValue);

			} else if (typeof logoValue === "string") {

				const logoUrl =
					`https://tripolaav2image.netcluesdemo.com/uploads/logo/${logoValue}`;

				console.log("Tripola Logo URL:", logoUrl);

				setTripolaCompanyLogoPreview(logoUrl);
			}

		} else {
			setTripolaCompanyLogoPreview("");
		}

	}, [
		formik.values.tripolaCompanyLogo,
		formik.values.tripolaCompanyLogo
	]);

	useEffect(() => {
		if (!isEditing && formik.values.tripolaCompanyName && !formik.values.tripolaIsVerified && !isManuallyEdited && (!tenantId || isTrialPortalCreation)) {
			const generatedDomain = generateFullDomain(formik.values.tripolaCompanyName);
			formik.setFieldValue("tripolaDomainUrl", generatedDomain);
			setButtonColor("");
			formik.setFieldValue("tripolaIsVerified", false);
			// setIsButtonDisabled(false);
			setResponseMessage("");
		}
	}, [formik.values.tripolaCompanyName, isEditing, formik.values.tripolaIsVerified, isManuallyEdited, tenantId, isTrialPortalCreation]);

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
			<Grid container spacing={3} pb={1}>
				<Grid item xs={12} md={6}>
					<Typography variant="subtitle2" gutterBottom>Company Name<span className="text-danger ms-1">*</span></Typography>
					<TextField placeholder="Enter company name" name="tripolaCompanyName" size="small" value={formik.values.tripolaCompanyName} onChange={handleCompanyNameChange} onBlur={(e) => { formik.setFieldValue("tripolaCompanyName", e.target.value.trim()); formik.handleBlur(e); }} error={formik.touched.tripolaCompanyName && Boolean(formik.errors.tripolaCompanyName)} helperText={formik.touched.tripolaCompanyName && formik.errors.tripolaCompanyName} disabled={Boolean(tenantId) && !isTrialPortalCreation} fullWidth />
				</Grid>
				<Grid item xs={12} md={6}>
					<Typography variant="subtitle2" gutterBottom>Domain <span className="text-danger ms-1">*</span></Typography>
					<Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25 }}>
						<Box sx={{ flex: 1 }}>
							<TextField name="tripolaDomainUrl" type="text" size="small" value={formik.values.tripolaDomainUrl} onChange={(e) => { if (isEditing) { const value = e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ""); formik.setFieldValue("tripolaDomainUrl", value); } }} onBlur={formik.handleBlur} error={formik.touched.tripolaDomainUrl && Boolean(formik.errors.tripolaDomainUrl)} helperText={formik.touched.tripolaDomainUrl && formik.errors.tripolaDomainUrl} fullWidth disabled={!isEditing} placeholder={isEditing ? "Enter subdomain" : ""} InputProps={{ endAdornment: isEditing && (<Typography variant="body2" color="textSecondary" sx={{ whiteSpace: "nowrap" }}>.{baseDomain}</Typography>) }} />
						</Box>
						<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
							{isEditing ? (<><Tooltip title="Save"><IconButton className="text-primary border border-primary" type="button" onClick={handleSaveDomainUrl}><SaveIcon fontSize="small" /></IconButton></Tooltip><Tooltip title="Cancel"><IconButton className="text-danger border border-danger" type="button" onClick={handleCancelEdit}><CloseIcon fontSize="small" /></IconButton></Tooltip></>) : (<>{(!tenantId || isTrialPortalCreation) && (<Tooltip title="Edit"><span style={{ cursor: (!formik.values.tripolaDomainUrl || (Boolean(tenantId) && !isTrialPortalCreation)) ? 'not-allowed' : 'pointer' }}><IconButton className="text-primary border border-primary" type="button" onClick={handleEditClick} disabled={!formik.values.tripolaDomainUrl || (Boolean(tenantId) && !isTrialPortalCreation)} sx={{ "&.Mui-disabled": { opacity: 0.5 } }}><EditIcon fontSize="small" /></IconButton></span></Tooltip>)}</>)}
							{!isEditing && (
								<>
									{formik.values.tripolaIsVerified ? (
										<Tooltip title="Verified">
											<span style={{ cursor: "not-allowed" }}>
												<IconButton className="text-success border border-success"
													disabled={true}
													sx={{ "&.Mui-disabled": { opacity: 0.5 } }}>
													<MyVerifiedIcon fontSize="small" className="text-success" />
												</IconButton>
											</span>
										</Tooltip>
									) : (
										<Tooltip title={formik.values.tripolaIsVerified ? "Verified" : "Verify Domain"}>
											<span style={{ cursor: formik.values.tripolaIsVerified ? "not-allowed" : "pointer" }}>
												<IconButton
													className={buttonColor === "success" ||
														formik.values.tripolaIsVerified ? "text-success border border-success success" :
														buttonColor === "error" ? "text-danger border border-danger" : "text-primary border border-primary"}
													onClick={verifyDomainURL}
													disabled={formik.values.tripolaIsVerified}
													sx={{ "&.Mui-disabled": { opacity: 0.5 } }}>
													<MyVerifiedIcon fontSize="small"
														className={buttonColor === "success" ||
															formik.values.tripolaIsVerified ? "text-success" : buttonColor === "error" ? "text-danger" : "text-primary"} />
												</IconButton>
											</span>
										</Tooltip>
									)}
								</>
							)}
						</Box>
					</Box>
					{formik.touched.tripolaIsVerified && formik.errors.tripolaIsVerified && !formik.values.tripolaIsVerified && (<Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>{formik.errors.tripolaIsVerified}</Typography>)}
					{responseMessage && (<Typography variant="caption" color={buttonColor === "success" ? "success.main" : "error.main"} sx={{ mt: 0.5, display: "block" }}>{responseMessage}</Typography>)}
				</Grid>
				<Grid item xs={12} md={6}>
					<Typography variant="subtitle2" gutterBottom>Company Email<span className="text-danger ms-1">*</span></Typography>
					<TextField placeholder="Enter company email" name="tripolaCompanyEmail" size="small" value={formik.values.tripolaCompanyEmail} onChange={handleEmailChange} onBlur={formik.handleBlur} error={formik.touched.tripolaCompanyEmail && Boolean(formik.errors.tripolaCompanyEmail)} helperText={formik.touched.tripolaCompanyEmail && formik.errors.tripolaCompanyEmail} fullWidth />
				</Grid>
				<Grid item xs={12} md={6}>
					<Typography variant="subtitle2" gutterBottom>Company Phone Number<span className="text-danger ms-1">*</span></Typography>
					<Box>
						<PhoneInput
							placeholder="Enter company phone number"
							country={"us"}
							value={formik.values.tripolaCompanyPhoneNumber}
							onChange={(phone) =>
								formik.setFieldValue("tripolaCompanyPhoneNumber", phone)
							}
							onBlur={() =>
								formik.setFieldTouched("tripolaCompanyPhoneNumber", true)
							}
							inputStyle={{
								width: "100%",
								height: "40px",
								fontSize: "14px",
								border:
									formik.touched.tripolaCompanyPhoneNumber &&
										formik.errors.tripolaCompanyPhoneNumber
										? "1px solid red"
										: "1px solid #ced4da",
							}}
						/>

						{formik.touched.tripolaCompanyPhoneNumber &&
							formik.errors.tripolaCompanyPhoneNumber && (
								<Typography
									variant="caption"
									color="error"
									sx={{ mt: 0.5, display: "block" }}
								>
									{formik.errors.tripolaCompanyPhoneNumber}
								</Typography>
							)}
					</Box>
				</Grid>
				<Grid item xs={12} md={6}>
					<Typography variant="subtitle2" gutterBottom>Company Zip Code<span className="text-danger ms-1">*</span></Typography>
					<TextField placeholder="Enter company zip code" type="text" name="tripolaCompanyZipCode" size="small" value={formik.values.tripolaCompanyZipCode} onChange={handleZipCodeChange} onBlur={formik.handleBlur} error={formik.touched.tripolaCompanyZipCode && Boolean(formik.errors.tripolaCompanyZipCode)} helperText={formik.touched.tripolaCompanyZipCode && formik.errors.tripolaCompanyZipCode} fullWidth />
				</Grid>
				<Grid item xs={12} md={6}>
					<Typography variant="subtitle2" gutterBottom>
						Company City<span className="text-danger ms-1">*</span>
					</Typography>

					<TextField
						placeholder="Enter company city"
						name="tripolaCompanyCity"
						size="small"
						value={formik.values.tripolaCompanyCity}
						onChange={(e) => {
							formik.setFieldValue(
								e.target.name,
								e.target.value.replace(/^\s+/, "")
							);
							formik.setFieldTouched(e.target.name, true, false);
						}}
						onBlur={(e) => {
							formik.setFieldValue(
								"tripolaCompanyCity",
								e.target.value.trim()
							);
							formik.handleBlur(e);
						}}
						error={
							formik.touched.tripolaCompanyCity &&
							Boolean(formik.errors.tripolaCompanyCity)
						}
						helperText={
							formik.touched.tripolaCompanyCity &&
							formik.errors.tripolaCompanyCity
						}
						fullWidth
					/>
				</Grid>
				<Grid item xs={12} md={6}>
					<Typography
						sx={{
							fontSize: "14px",
							fontWeight: 600,
							mb: 1,
							color: "#1f2937",
						}}
					>Currency <span className="text-danger ms-1">*</span></Typography>
					<TextField sx={{
						"& .MuiOutlinedInput-root": {
							height: "42px",
							borderRadius: "12px",
						},
					}} select name="tripolaCurrency" size="small" placeholder="Select Currency" value={formik.values.tripolaCurrency} onChange={formik.handleChange} onBlur={formik.handleBlur} error={formik.touched.tripolaCurrency && Boolean(formik.errors.tripolaCurrency)} helperText={formik.touched.tripolaCurrency && formik.errors.tripolaCurrency} fullWidth>
						{tenantCurrencies.map((tripolaCurrency) => (<MenuItem key={tripolaCurrency.id} value={tripolaCurrency.id}>{tripolaCurrency?.name || ""} - {tripolaCurrency?.symbol || ""}</MenuItem>))}
					</TextField>
				</Grid>

				<Grid item xs={12} md={6}>
					<Typography variant="subtitle2" gutterBottom>Company Logo</Typography>
					<Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: 2, border: "2px dashed #ccc", borderRadius: 1, backgroundColor: "#fafafa", textAlign: "center", cursor: "pointer", transition: "all 0.3s ease", "&:hover": { borderColor: "var(--bs-primary)", backgroundColor: "#f0f7ff" } }} component="label">
						{tripolaCompanyLogoPreview ? (<Box sx={{ position: "relative", display: "inline-block" }}><Avatar src={tripolaCompanyLogoPreview} sx={{ width: 100, height: 100, margin: "0 auto", border: "2px solid var(--bs-primary)" }} /><Button size="small" variant="contained" color="error" startIcon={<DeleteIcon />} onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleRemovetripolaCompanyLogo(); }} sx={{ mt: 1 }}>Remove</Button></Box>) : (<Box><CloudUploadIcon sx={{ fontSize: 48, color: "var(--bs-primary)", mb: 1 }} /><Typography variant="body2" color="textSecondary">Click to upload or drag and drop</Typography><Typography variant="caption" color="textSecondary">PNG, JPG, GIF or WebP (Max 5MB)</Typography></Box>)}
						<input hidden accept="image/*" type="file" onChange={handletripolaCompanyLogoChange} />
					</Box>
					{formik.touched.tripolaCompanyLogo && formik.errors.tripolaCompanyLogo && (<Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>{formik.errors.tripolaCompanyLogo}</Typography>)}
				</Grid>
			</Grid>
		</Box>
	);
};

export default TripolaInformationStep;
